import { render, staticRenderFns } from "./ScrollIndicator.vue?vue&type=template&id=2915b9e2&scoped=true&"
import script from "./ScrollIndicator.vue?vue&type=script&lang=js&"
export * from "./ScrollIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ScrollIndicator.vue?vue&type=style&index=0&id=2915b9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2915b9e2",
  null
  
)

export default component.exports